export type IPipelineState = {
  type: string
  tasks?: ReducedTaskInstance[]
}

export type PipelineNoneState = IPipelineState & {
  type: 'NONE'
  tasks: undefined
}

export type PipelineCompletedState = IPipelineState & {
  type: 'COMPLETED'
  tasks: undefined
}

export type PipelineProgressState = IPipelineState & {
  type: 'PROGRESS'
  tasks: ReducedTaskInstance[]
}

export type PipelineErrorState = IPipelineState & {
  type: 'ERROR'
  tasks: ReducedTaskInstance[]
}

export type ReducedTaskInstance = {
  taskName: string
  state: AirflowSuccessStates | AirflowErrorStates | AirflowProgressStates | AirflowNoneStates
  duration?: number
}

export type AirflowSuccessStates = 'success'
export type AirflowErrorStates = 'failed'
export type AirflowProgressStates = 'running' | 'up_for_retry' | 'up_for_reschedule' | 'queued' | 'scheduled' | 'deferred' | 'restarting'
export type AirflowNoneStates = 'upstream_failed' | 'skipped' | 'none' | 'removed'

export const AirflowErrorStatesSet: AirflowErrorStates[] = ['failed']
export const AirflowProgressStatesSet: AirflowProgressStates[] = [
  'running',
  'up_for_retry',
  'up_for_reschedule',
  'queued',
  'scheduled',
  'deferred',
  'restarting'
]
export const AirflowNoneStatesSet: AirflowNoneStates[] = ['upstream_failed', 'skipped', 'none', 'removed']
export const AirflowSuccessStatesSet: AirflowSuccessStates[] = ['success']
